module.exports = __webpack_public_path__ + "2e16f97dfba94954552818dd079e44a0.png";